/** A surface above the page. Hairline border, no shadow — `DESIGN.md` calls for a flat
 *  architecture, and a shadow here would be the first crack in that. */

import type { HTMLAttributes, ReactNode } from "react";

import { cx } from "./cx";

export interface CardProps extends HTMLAttributes<HTMLElement> {
  /** Rendered as an `h2` with the card labelled by it, so the region is navigable. */
  title?: string;
  /** Actions aligned to the inline end of the header, so they mirror in Arabic. */
  actions?: ReactNode;
  as?: "section" | "article" | "div";
}

export function Card({
  title,
  actions,
  as: Element = "section",
  className,
  children,
  ...rest
}: CardProps): JSX.Element {
  return (
    <Element
      className={cx(
        "rounded-md border border-borderSubtle bg-surfaceRaised p-4",
        className,
      )}
      {...rest}
    >
      {title || actions ? (
        <header className="mb-4 flex flex-wrap items-center justify-between gap-3">
          {title ? <h2 className="text-heading-sm text-textPrimary">{title}</h2> : <span />}
          {actions}
        </header>
      ) : null}
      {children}
    </Element>
  );
}
